import {RECEIVE_NETWORKS, LOAD_NETWORKS} from "../actions/PriceCalculator";

const default_state = {
  networks: [],
  loading: false,
};


export const pricesReducer = (state = default_state, action) => {
  switch(action.type) {
    case LOAD_NETWORKS:
      state = Object.assign({}, state, {loading: true, networks: []});
      break;
    case RECEIVE_NETWORKS:
      state = Object.assign({}, state, {networks: action.networks, loading: false});
      break;
    default:
  }

  return state
};




// WEBPACK FOOTER //
// ./src/reducers/PriceCalculator.js